import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import type { MarkExportedRequest } from "../types";
import { invalidateEvalStewardQueries } from "../utils/invalidateEvalStewardQueries";

export interface MarkAnnotationExportedVariables {
  workspaceId: string;
  annotationId: string;
  threadId: string;
  assistantMessageIndex: number;
  body: MarkExportedRequest;
}

export function useMarkAnnotationExported() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      workspaceId,
      annotationId,
      body,
    }: MarkAnnotationExportedVariables) =>
      api.markEvalAnnotationExported(workspaceId, annotationId, body),
    onSuccess: (_annotation, variables) => {
      invalidateEvalStewardQueries(
        queryClient,
        {
          workspaceId: variables.workspaceId,
          threadId: variables.threadId,
          assistantMessageIndex: variables.assistantMessageIndex,
        },
        variables.annotationId,
      );
    },
  });
}
